export default __webpack_public_path__ + "src/_images/ISA_Wide2.png";